import React, { useState, useEffect } from "react";
import footer_en from "../resources/en/footer.js";
import footer_es from "../resources/es/footer.js";
import footer_pt from "../resources/br/footer.js";
import routeNames_br from "../resources/br/routeNames";
import routeNames_en from "../resources/en/routeNames";
import routeNames_es from "../resources/es/routeNames";

const Footer = (props) => {
  const availableLanguages =
    process.env.REACT_APP_AVAILABLE_LANGUAGES.split(" ");
  const storedLang = JSON.parse(localStorage.getItem("language"));
  const currentLanguage =
    (storedLang && availableLanguages.includes(storedLang.lang)
      ? storedLang.lang
      : process.env.REACT_APP_DEFAULT_LANGUAGE) || "br";
  const currentYear = new Date().getUTCFullYear();

  const [style] = useState({
    igMediaColor: "#0494db",
    fbMediaColor: "#0494db",
    lnMediaColor: "#0494db",
    cookieClass: props.hasTranslation ? null : "noTranslation",
  });
  
  const [language, setLanguage] = useState(currentLanguage);

  useEffect(() => {
    if (props.language && props.language !== language) {
      setLanguage(props.language);
    }
  }, [props.language, language]);

  const textsFooter = { en: footer_en, br: footer_pt, es: footer_es };
  const routeNames = {
    en: routeNames_en,
    br: routeNames_br,
    es: routeNames_es,
  };

  const handleLanguage = (lang) => {
    if (currentLanguage !== lang) {
      setLanguage(lang);
      props.setHistory(lang);
      window.location.reload();
    }
  };

  return (
    <div   translate="no" className="notranslate footer">
      <div   translate="no" className="notranslate copyright">
        <p>
          <small>
            © {currentYear} - {textsFooter[language].rights}
          </small>
        </p>
      </div>
      <div   translate="no" className={"cookies " + style.cookieClass}>
        <a
            translate="no"
          href={
            "/" +
            language +
            "/" +
            routeNames[language]["politica-de-privacidade"]
          }
          className="notranslate cookieItem"
        >
          {textsFooter[language].privacyPolicy}
        </a>
        <span   translate="no" className="notranslate cookieDot">
          ·
        </span>
        <span
            translate="no"
          id="cookieButton"
          onClick={() => {
            window.LGPD_API
              ? window.LGPD_API.openConfigDialog()
              : console.log("requisição em andamento");
          }}
          className="notranslate cookieItem"
        >
          Cookies
        </span>
      </div>
      {props.hasTranslation && (
        <div   translate="no" className="notranslate languages">
          {availableLanguages.map((lang) => (
            <span
              key={lang}
                translate="no"
              onClick={() => handleLanguage(lang)}
              className={
                language === lang ? "languageItem activeLang" : "languageItem"
              }
            >
              {lang.toUpperCase()}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

Footer.propTypes = {};

export default Footer;
